export interface SelectItem<T = any> {
  label: string;
  value: T;
  selected?: boolean;
}

type LabelFunc<T> = (item: T) => string;

export function toSelectItem<T extends any>(
  label: keyof T | LabelFunc<T>,
  value: keyof T,
): (item: T) => SelectItem {
  return (item: T) => {
    const getLabel = (itm: T, lbl: keyof T | LabelFunc<T>) =>
      typeof lbl === 'string' ? ((itm[lbl] as unknown) as string) : (lbl as LabelFunc<T>)(itm);

    return { label: getLabel(item, label), value: item[value] };
  };
}

export function toSelectionList<T extends { [id: string]: any }>(
  label: keyof T | LabelFunc<T>,
  value: keyof T,
) {
  return (items: T[]) => items.map(toSelectItem<T>(label, value));
}
